import { gql } from "@apollo/client";

export const processOrder = gql`
    mutation ProcessOrder($processOrderId: ID!, $status: String, $quantity: Int) {
        processOrder(id: $processOrderId, status: $status, quantity: $quantity)
    }
`;

export const changeSupplierStatus = gql`
    mutation ChangeSupplierStatus($changeSupplierStatusId: ID!, $supplierStatus: String) {
        changeSupplierStatus(id: $changeSupplierStatusId, supplier_status: $supplierStatus)
    }
`;

export const createCustomer = gql`
    mutation CreateCustomer($input: CustomerInput) {
        createCustomer(input: $input) {
            id
            name
            phone
            email
            address {
                id
                area
                city
                country
                landmark
            }
        }
    }
`;

export const createOrder = gql`
    mutation CreateOrder($input: OrderCreateInput) {
     createOrder(input: $input)
}
`;